import { SectionType } from "../types";

const promoteableSections: SectionType["sys"]["contentType"]["sys"]["id"][] = [
  "centeredRichText",
  "textimageSection",
  "privacySection",
  "splitTextSection",
];

export default function promoteH1RenderSectionMiddleware(
  sections: SectionType[]
) {
  let hasPromotedSection = false;

  return sections.map((section) => {
    if (hasPromotedSection) return section;
    if (promoteableSections.includes(section.sys.contentType.sys.id)) {
      hasPromotedSection = true;
      return { ...section, promoteH1: true };
    }
    return section;
  });
}
